import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Loading from 'react-loading';
import { Form } from 'semantic-ui-react';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { useMutation } from '@apollo/react-hooks';
import { MdSend } from 'react-icons/md';
import { toast } from 'react-toastify';

import { Main, Button, Send } from './styles';

import { UPDATE_CAMERA } from '../../../services/graphql/mutations';
import { GET_CAMERAS } from '../../../services/graphql/queries';

import { schema, formInitialState, formErrorInitialState } from './constants';

export default function Modal({
  edit,
  onClose,
  selectedValue,
  open,
  mallAccessOptions,
  lprConfigOptions,
  selected = {}
}) {
  const [
    { mall_acc_id, lane, lpr_id, lpr_cat_id, direction, active },
    setFormState
  ] = useState(formInitialState);
  const [
    {
      mall_acc_idError,
      laneError,
      lpr_idError,
      lpr_cat_idError,
      directionError
    },
    setFormErrorState
  ] = useState(formErrorInitialState);

  const [updateCamera, { loading: updateLoading }] = useMutation(UPDATE_CAMERA);

  useEffect(() => {
    if (open) {
      setFormState(formInitialState);
      setFormErrorState(formErrorInitialState);
    }

    if (edit && open) {
      const {
        mall_acc_id,
        lane,
        lpr_id,
        lpr_cat_id,
        direction,
        active
      } = selected;

      setFormState({
        mall_acc_id,
        lane,
        lpr_id,
        lpr_cat_id,
        direction,
        active
      });
    }
  }, [open, edit, selected]);

  function handleOnChange(name, value) {
    setFormState(prevState => ({ ...prevState, [name]: value }));
  }

  async function handleSubmit() {
    try {
      setFormErrorState(formErrorInitialState);

      await schema.validate(
        { mall_acc_id, lane, lpr_id, lpr_cat_id, direction },
        { abortEarly: false }
      );

      const editCameraInput = {
        id: selected.id,
        mall_acc_id,
        lane,
        lpr_id,
        lpr_cat_id,
        direction,
        active,
        last_update: new Date()
      };
      await updateCamera({
        variables: {
          editCameraInput
        },
        refetchQueries: [{ query: GET_CAMERAS }]
      });

      setFormState(formInitialState);

      toast.success('El registro fue editado exitosamente');

      handleClose();
    } catch (err) {
      if (err.inner) {
        err.inner.map(error =>
          setFormErrorState(prevState => ({
            ...prevState,
            [`${error.path}Error`]: true
          }))
        );
      } else {
        toast.error('Error al intentar actualizar el registro');
      }
    }
  }

  function handleClose() {
    onClose(selectedValue);
  }

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <DialogTitle id="simple-dialog-title">Editar Cámara</DialogTitle>
      <Main data-testid="modal-component">
        <Form>
          <Form.Group>
            <Form.Select
              error={mall_acc_idError}
              label="Configuración de Acceso *"
              placeholder="Seleccione Configuración de Acceso"
              options={mallAccessOptions}
              width={6}
              value={mall_acc_id}
              onChange={(e, { value }) => handleOnChange('mall_acc_id', value)}
            />
            <Form.Input
              error={laneError}
              label="Carril"
              placeholder="Carril"
              width={4}
              value={lane}
              onChange={(e, { value }) => handleOnChange('lane', value)}
            />
            <Form.Select
              error={lpr_idError}
              label="Configuración de Servicio *"
              placeholder="Seleccione Configuración de Servicio"
              options={lprConfigOptions}
              width={6}
              value={lpr_id}
              onChange={(e, { value }) => handleOnChange('lpr_id', value)}
            />
          </Form.Group>

          <Form.Group>
            <Form.Input
              error={lpr_cat_idError}
              label="ID Cámara *"
              placeholder="ID Cámara"
              width={4}
              value={lpr_cat_id}
              onChange={(e, { value }) => handleOnChange('lpr_cat_id', value)}
            />
            <Form.Input
              error={directionError}
              label="Sentido *"
              placeholder="Sentido"
              width={4}
              value={direction}
              onChange={(e, { value }) => handleOnChange('direction', value)}
            />
          </Form.Group>

          <Form.Group>
            <Form.Checkbox
              label="Activo"
              width={2}
              onClick={() => handleOnChange('active', !active)}
              checked={active}
            />
          </Form.Group>
        </Form>
        <Button onClick={handleSubmit} data-testid="send-button">
          {updateLoading ? (
            <Loading height={15} width={15} type="spin" />
          ) : (
            <Send>
              <MdSend />
              Enviar
            </Send>
          )}
        </Button>
      </Main>
    </Dialog>
  );
}

Modal.propTypes = {
  edit: PropTypes.bool,
  onClose: PropTypes.func,
  selectedValue: PropTypes.any,
  open: PropTypes.bool,
  selected: PropTypes.object,
  lprConfigOptions: PropTypes.array,
  mallAccessOptions: PropTypes.array
};
